/* Phos & Gaia — Collection 2026 behaviours (scoped to the redesign template). */
(() => {
  document.body.classList.add('pg-2026');

  const money = (c) => new Intl.NumberFormat('el-GR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100);

  /* Open the theme's own cart drawer by triggering its header toggle. */
  function openCart() {
    const el = document.querySelector('cart-drawer');
    if (el && typeof el.open === 'function') return el.open();
    const toggle = document.querySelector('#cart-icon-bubble, [data-cart-drawer-toggle], a[href$="/cart"]:not(.pg-ship)');
    if (toggle) return toggle.click();
    window.location.href = window.Shopify.routes.root + 'cart';
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-pg-cart-open]')) { e.preventDefault(); openCart(); }
  });

  async function refreshShip() {
    const bar = document.querySelector('.pg-ship');
    if (!bar) return;
    const cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
    const threshold = parseInt(bar.dataset.threshold, 10) || 4900;
    const left = threshold - cart.total_price;
    const msg = bar.querySelector('[data-pg-ship-msg]');
    const sum = bar.querySelector('[data-pg-cart-summary]');
    const fill = bar.querySelector('[data-pg-ship-bar]');
    if (fill) fill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    if (msg) msg.innerHTML = cart.item_count === 0
      ? 'Δωρεάν αποστολή άνω των <b>' + money(threshold) + '</b>'
      : left > 0 ? '<b>' + money(left) + '</b> για δωρεάν αποστολή' : '<b>Έχετε δωρεάν αποστολή ✓</b>';
    if (sum && cart.item_count > 0) {
      sum.className = 'pg-ship__go';
      sum.textContent = cart.item_count + ' στο καλάθι · ' + money(cart.total_price) + ' ›';
    }
  }

  /* Sleek submits quick-add via its own product-form; refresh after any cart mutation. */
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const p = origFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (/\/cart\/(add|change|update)/.test(url)) p.then(() => setTimeout(refreshShip, 250)).catch(() => {});
    return p;
  };
  document.addEventListener('cart:updated', refreshShip);
  document.addEventListener('cart:refresh', refreshShip);

  /* Keep the sticky filter/toolbar offset in sync with the real header height. */
  const header = document.querySelector('#shopify-section-header, .section-header, header');
  const sync = () => {
    if (!header) return;
    document.documentElement.style.setProperty('--pg-header-h', Math.round(header.getBoundingClientRect().height) + 'px');
  };
  sync();
  window.addEventListener('resize', sync);
})();
